// extracted by mini-css-extract-plugin
module.exports = {"list":"tags_list__wlxub","item":"tags_item__JWd58","upperCase":"tags_upperCase__LOm1i"};